import updateConfigLocale from "../utils/updateConfigLocale";

class ClientLocaleInterceptor {
  constructor() {
    this.locale = null;
    this.intercept = this.intercept.bind(this);
  }

  setLocale(locale) {
    this.locale = locale;
  }

  intercept(requestConfig) {
    return updateConfigLocale(requestConfig, this.locale);
  }

  getInterceptor() {
    return this.intercept;
  }
}

const clientLocaleInterceptor = new ClientLocaleInterceptor();

export default clientLocaleInterceptor;
